import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewTableComponent } from "./med-icon-view-table.component";

@NgModule({
  declarations: [
    MedIconViewTableComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewTableComponent,
  ],
})
export class MedIconViewTableModule { }
